import styled from 'styled-components'

export const RequiredAsterisk = styled.span`
  &::before {
    content: '*';
    color: ${o => o.theme.color.deprecated.red.error};
    font-size: 15px;
    line-height: ${o => o.theme.spacing(4)};
    font-weight: ${o => o.theme.typography.deprecated.font.weight.bold};
    vertical-align: 1px;
  }
`
